import {
  ToggleButton,
  ToggleButtonGroup,
  ToggleButtonGroupProps,
} from '@mui/material';
import React from 'react';

interface Props<T = string>
  extends Omit<ToggleButtonGroupProps, 'value' | 'onChange'> {
  buttons: {
    value: T;
    label: string;
  }[];
  value: T;
  onChange: (value: T) => void;
}

function ChartToggleButtonGroup<T extends string>({
  buttons,
  value,
  onChange,
  ...rest
}: Props<T>) {
  const defaultValue = buttons[0].value;
  const isSingleButton = buttons.length === 1;
  const handleChange = (
    event: React.MouseEvent<HTMLElement>,
    newValue: T | null,
  ) => {
    if (newValue !== null) {
      onChange(newValue);
    }
  };

  return (
    <ToggleButtonGroup
      value={value || defaultValue}
      exclusive
      onChange={handleChange}
      sx={{
        '&.Mui-selected:hover': {
          backgroundColor: '#777',
        },
        '.MuiToggleButton-root': {
          padding: '6px',
          fontSize: '12px',
          height: '33px',
          ...(isSingleButton && {
            backgroundColor: '#777',
            color: '#fff',
          }),
        },
        '.MuiToggleButton-root.Mui-selected': {
          '&:hover': {
            backgroundColor: '#777',
          },
          background: '#777',
          color: '#fff',
        },
        '.MuiButtonBase-root': {
          fontWeight: 700,
        },
      }}
      color={rest.color}
      disabled={rest.disabled}
      fullWidth={rest.fullWidth}
      orientation={rest.orientation}
      size={rest.size}
    >
      {buttons.map(({ value, label }) => (
        <ToggleButton value={value} key={value}>
          {label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}

export default ChartToggleButtonGroup;
